export default __webpack_public_path__ + "static/media/bla.2e5e5aff.svg";